import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSmartBack } from "@/hooks/useSmartBack";

interface BackButtonProps {
  to: string;
  label?: string;
  onClick?: () => void;
  className?: string;
  useSmartNavigation?: boolean;
}

const BackButton = ({
  to,
  label = "Back",
  onClick,
  className,
  useSmartNavigation = false
}: BackButtonProps) => {
  const navigate = useNavigate();
  const smartBack = useSmartBack(to);
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (useSmartNavigation) {
      // Use smart back navigation with fallback
      smartBack();
    } else {
      // Direct navigation to specified path
      navigate(to);
    }
  };

  return (
    <Button 
      variant="ghost" 
      className={cn(
        "mb-4 group hover:bg-primary/5 transition-colors",
        // Mobile optimization: adequate touch target (min 44x44px)
        "min-h-[44px] min-w-[44px]",
        // Responsive padding
        "px-3 py-2 md:px-4 md:py-2",
        className
      )}
      onClick={handleClick}
      aria-label={label}
    >
      <ArrowLeft className="h-4 w-4 mr-2 group-hover:-translate-x-1 transition-transform" />
      <span className="text-sm font-medium">{label}</span>
    </Button>
  );
};

export default BackButton;
